export default "__VITE_ASSET__BkB8pAz$__"